/* eslint-disable @reatom/unit-naming-rule */
import { action, reaction, reatomArray, withAssign } from '@reatom/framework'

import { reatomPathfinderQuoteSubscription } from '@root/features/quote/atoms/reatom-quote-subscription'

import { instantBuyQuickOptionsAtom } from './reatom-instant-buy'

import type { PairModel } from '@root/entities/pair/atoms'
import type { PathfinderQuoteSubscriptionModel } from '@root/features/quote/atoms/reatom-quote-subscription'
import type { BigNumber } from 'bignumber.js'

type QuoteMeta = {
  amount: BigNumber
  quoteModel: PathfinderQuoteSubscriptionModel
}

export const reatomInstantBuyQuote = ({ pair }: { pair: PairModel }) => {
  const modelsAtom = reatomArray<QuoteMeta>([])

  const subscribeReaction = reaction((ctx) => {
    const options = ctx.spy(instantBuyQuickOptionsAtom)
    const models = ctx.get(modelsAtom)
    for (const [index, option] of options.entries()) {
      const existing = models[index]
      if (existing) {
        if (existing.amount.eq(option)) {
          continue
        }
        existing.quoteModel.unsubscribe(ctx)
        modelsAtom.toSpliced(ctx, index, 1)
      }
      const quoteModel = reatomPathfinderQuoteSubscription({
        pair,
        amount: option,
        type: 'buy',
      })
      quoteModel.subscribe(ctx)
      modelsAtom.push(ctx, {
        amount: option,
        quoteModel,
      })
    }
  })

  const unsubscribeAllAction = action(async (ctx) => {
    const models = ctx.get(modelsAtom)
    for (const model of models) {
      model.quoteModel.unsubscribe(ctx)
    }
    modelsAtom(ctx, [])
  })

  return modelsAtom.pipe(
    withAssign(() => ({
      subscribe: subscribeReaction,
      unsubscribe: unsubscribeAllAction,
    })),
  )
}
